module.exports = __webpack_public_path__ + "static/pillow-1-ow-e22557152e664412c0aec7947e00aed9.png";